<template>
  <div class="messageSuccess wv100 hv100 pl16 pr16">
    <div>
      <p class="m0">
        <span class="icon"><van-icon name="success"/></span>
      </p>
      <p class="msg">
        {{ msg }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    msg: String
  },
  data() {
    return {};
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scope>
.messageSuccess {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    display: inline-block;
    font-size: 55px;
    text-align: center;
    background: #4994df;
    color: #ffffff;
    width: 80px;
    height: 80px;
    border-radius: 80px;
    line-height: 80px;
    i {
      line-height: 80px;
      width: 80px;
      height: 80px;
    }
  }
  .msg {
    font-size: 22px;
  }
}
</style>
